// src/components/LoadingSpinner.jsx
import React from "react";
import PropTypes from "prop-types";

// CSS trực tiếp trong component (có thể tách ra file CSS riêng nếu muốn)
const styles = `
  .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 20px;
  }
  .spinner-circle {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  .spinner-text {
    margin-left: 10px;
    font-size: 16px;
    color: #3498db;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  /* Hiệu ứng thanh ngang */
  .spinner-bar {
    width: 50px;
    height: 4px;
    background: #3498db;
    animation: slide 1.5s infinite;
  }
  @keyframes slide {
    0% { transform: translateX(-100%); }
    50% { transform: translateX(100%); }
    100% { transform: translateX(-100%); }
  }
  /* Hiệu ứng chấm nhảy */
  .spinner-dots {
    display: flex;
    gap: 5px;
  }
  .dot {
    width: 10px;
    height: 10px;
    background: #3498db;
    border-radius: 50%;
    animation: bounce 0.5s infinite alternate;
  }
  .dot:nth-child(2) { animation-delay: 0.2s; }
  .dot:nth-child(3) { animation-delay: 0.4s; }
  @keyframes bounce {
    0% { transform: translateY(0); }
    100% { transform: translateY(-10px); }
  }
`;

const LoadingSpinner = ({
  type = "circle",
  color = "#3498db",
  size = 40,
  text = "Đang tải...",
}) => {
  // Điều chỉnh kiểu dáng dựa trên props
  const spinnerStyle = {
    border: type === "circle" ? `4px solid #f3f3f3` : "none",
    borderTop: type === "circle" ? `4px solid ${color}` : "none",
    width: `${size}px`,
    height: type === "bar" ? "4px" : `${size}px`,
    background: type === "bar" || type === "dots" ? color : "transparent",
  };

  const textStyle = {
    color,
  };

  return (
    <>
      <style>{styles}</style>
      <div className="spinner-container">
        {type === "circle" && (
          <div className="spinner-circle" style={spinnerStyle}></div>
        )}
        {type === "bar" && (
          <div className="spinner-bar" style={spinnerStyle}></div>
        )}
        {type === "dots" && (
          <div className="spinner-dots">
            <div className="dot" style={spinnerStyle}></div>
            <div className="dot" style={spinnerStyle}></div>
            <div className="dot" style={spinnerStyle}></div>
          </div>
        )}
        {text && (
          <span className="spinner-text" style={textStyle}>
            {text}
          </span>
        )}
      </div>
    </>
  );
};

// Định nghĩa propTypes để kiểm tra props
LoadingSpinner.propTypes = {
  type: PropTypes.oneOf(["circle", "bar", "dots"]),
  color: PropTypes.string,
  size: PropTypes.number,
  text: PropTypes.string,
};

export default LoadingSpinner;
